import {mode$} from '@px/streams/spot';
import {conditionalOrders$ as spotConditionalOrders$, conditionalOrderCount$ as spotConditionalOrderCount$} from '@px/streams-spot/order-conditional';
import {conditionalOrders$ as marginConditionalOrders$, conditionalOrderCount$ as marginConditionalOrderCount$} from '@px/streams-margin/order-conditional';
import {SPOT_TRADE_MODE} from './enum';
import {createSpotModeState$} from './utils';

export const [conditionalOrders$] = createSpotModeState$<SpotPairConditionalOrders>(
  mode$,
  {
    [SPOT_TRADE_MODE.Margin]: marginConditionalOrders$,
    [SPOT_TRADE_MODE.Spot]: spotConditionalOrders$,
  },
  []
);

export const [conditionalOrderCount$] = createSpotModeState$<string>(
  mode$,
  {
    [SPOT_TRADE_MODE.Margin]: marginConditionalOrderCount$,
    [SPOT_TRADE_MODE.Spot]: spotConditionalOrderCount$,
  },
  ''
);
